import React, { Component } from 'react'
import { Group, Image, Label, Rect, Tag, Text } from 'react-konva'
import { KonvaEventObject } from 'konva/lib/Node'
import imageService from '../../../services/image.service'
import { gs1CarrierName } from '../../../apis/gs1.api'
import {
  Gs1BarcodeElement as Gs1BarcodeElementData
} from '../../../views/LabelBuilder/LabelBuilder.slice'

interface Props {
    element: Gs1BarcodeElementData
    carrierName?: string
    onClick?: (event: KonvaEventObject<MouseEvent>) => void
    onTransform?: (event: KonvaEventObject<MouseEvent>) => void
    onDrag?: (event: KonvaEventObject<DragEvent>) => void
    onRightClick?: (event: KonvaEventObject<PointerEvent>) => void
    draggable?: boolean
    name?: string
}

/**
 * The server-drawn preview of a GS1 Barcode, with its compliance tag. The
 * tag is designer chrome: markup.service leaves it out of snapshots and the
 * server prints from the saved settings, never from this picture.
 */
export default class Gs1BarcodeElement extends Component<Props> {
  render () {
    const { element, draggable = true } = this.props
    const valid = element.valid && !!element.url
    const image = valid ? imageService.generateImage(element.url) : undefined
    const carrier = this.props.carrierName || gs1CarrierName(element.gs1.carrier)
    const mark = valid ? `✓ ${carrier} · GS1 compliant` : `✕ ${carrier} · not compliant`
    // Above the barcode, or below it when there is no room above.
    const markY = element.y >= 18 ? -18 : element.height + 4

    return (
            <Group
                id={element.id}
                name={this.props.name}
                x={element.x}
                y={element.y}
                rotation={element.rotation}
                opacity={element.opacity}
                draggable={draggable}
                onClick={this.props.onClick}
                onTransformEnd={this.props.onTransform}
                onDragEnd={this.props.onDrag}
                onContextMenu={this.props.onRightClick}>
                {valid
                  ? <Image image={image} width={element.width} height={element.height}/>
                  : (
                    <Group>
                        <Rect
                            width={element.width}
                            height={element.height}
                            fill="#fef2f2"
                            stroke="#dc2626"
                            strokeWidth={1}
                            dash={[4, 3]}/>
                        <Text
                            width={element.width}
                            height={element.height}
                            align="center"
                            verticalAlign="middle"
                            padding={6}
                            fontSize={12}
                            fill="#991b1b"
                            text="No barcode is produced until the errors in the panel are fixed."/>
                    </Group>
                    )}
                <Label name="gs1-mark" y={markY} listening={false}>
                    <Tag fill={valid ? '#15803d' : '#dc2626'} cornerRadius={2}/>
                    <Text text={mark} fontSize={10} padding={3} fill="#ffffff" fontStyle="bold"/>
                </Label>
            </Group>
    )
  }
}
